import { Reveal } from "./Reveal";

export const About = () => (
  <section id="tentang" className="py-24 md:py-32 bg-[#F3ECDC] border-y border-[#211B10]/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 items-center">
      <Reveal className="md:col-span-4 flex justify-center md:justify-start">
        <div className="relative">
          <img
            src="/nalura-logo.jpg"
            alt="Logo NALURA"
            className="w-56 h-56 md:w-72 md:h-72 object-contain mix-blend-multiply"
            data-testid="about-logo"
          />
          <p className="text-center font-display text-3xl tracking-tight mt-2">
            NALURA<span className="text-[#A67C1E]">.</span>
          </p>
          <p className="text-center font-mono text-[9px] uppercase tracking-[0.3em] text-[#A67C1E] mt-1">
            Good Mind Good Life
          </p>
        </div>
      </Reveal>
      <div className="md:col-span-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-[#A67C1E] mb-6">Tentang NALURA</p>
          <h2 className="font-display tracking-tighter text-3xl md:text-5xl leading-tight mb-8 max-w-2xl">
            Nama kami lahir dari dua kata: <em className="italic text-[#A67C1E]">nalar</em> dan <em className="italic text-[#A67C1E]">aura</em>.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="space-y-5 text-sm md:text-base text-[#211B10]/70 leading-relaxed max-w-2xl" data-testid="about-story">
            <p>
              Kami percaya bahwa pikiran yang jernih memancarkan kehidupan yang terang. Ketika nalar dilatih dengan benar,
              ia menjadi aura — energi yang menarik peluang, ketenangan, dan kelimpahan. Itulah makna di balik NALURA,
              dan itulah janji di balik setiap program yang kami kurasi.
            </p>
            <p>
              NALURA bukan toko biasa. Kami menyaring puluhan program pengembangan diri dan hanya meloloskan yang benar-benar
              teruji — program yang membantu Anda fokus, menyembuhkan luka batin, menenangkan diri, bernegosiasi lebih baik,
              dan berpikir lebih kreatif. Satu prinsip sederhana memandu semuanya: <span className="text-[#211B10] font-medium">Good Mind, Good Life</span> —
              rawat pikiran Anda, dan hidup akan mengikuti.
            </p>
            <p>
              Setiap transaksi diproses aman melalui platform resmi penyedia program. Tugas kami satu: memastikan Anda
              memilih program yang tepat untuk fase hidup Anda saat ini.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
